import React, {useEffect, useRef, useState} from "react";
import "./notification.scss";
import { get, responseValidator } from "../api";
import { toast } from "react-toastify";
import { Spin } from "antd";
import useOnBlur from "../util/useOnBlue";
export default function Notification(props) {
    const [notif, setNotif] = useState([]);
    const boxRef=useRef(null)
    useEffect(() => {
        if (props.status) {
            get("/Notification/").then(response => {
                if (responseValidator(response.status)) {
                    console.log(response.data.data);
                    setNotif(response.data.data);
                } else {
                    toast.error(response.data.message);
                    if (response.status === 403)
                        setTimeout(() => {
                            window.location.replace("/authorization/");
                        }, 3000);
                }
            });
        } else setNotif(undefined);
    }, [props.status]);

    useOnBlur(boxRef,()=>props.status ? props.close() : null)

    return (
        <div ref={boxRef}  className={`notification-main-page ${props.status ? "open" : ""}`}>
            {notif ? (
                <div className="content">
                    {notif.length!==0 ? notif.map(item => (
                        <div className="items">
                            {item.type.id === 1 ? (
                                <i
                                    style={{ color: "blue" }}
                                    className="fas fa-info-circle"
                                />
                            ) : item.type.id === 2 ? (
                                <i
                                    style={{ color: "gold" }}
                                    className="fas fa-exclamation-triangle"
                                />
                            ) : (
                                <i
                                    style={{ color: "darkRed" }}
                                    className="fas fa-exclamation-circle"
                                />
                            )}
                            <p>
                                {item.message}
                                <br />
                                <span>
                                    {" "}
                                    {new Date(item.dateTime).toLocaleDateString(
                                        "fa-IR"
                                    ) +
                                        " - " +
                                        item.dateTime
                                            .split(":")[0]
                                            .slice(11, 13) +
                                        ":" +
                                        item.dateTime.split(":")[1]}
                                </span>
                            </p>
                        </div>
                    )) : <p className='not-found'>اطلاعاتی موجود نیست</p>}
                </div>
            ) : (
                <Spin />
            )}
        </div>
    );
}
